// Registri statici per la barra di ricerca globale (command palette).
//
// Al momento l'app non ha un catalogo pagine data-driven: le rotte sono
// definite a mano in app.routes.ts e i link nel menu laterale. Questo file
// centralizza la lista delle pagine/azioni ricercabili, con label italiane
// hardcoded coerenti col resto dell'app.

export type SearchSection = 'PAGINE' | 'AZIONI' | 'FATTURE' | 'CLIENTI';

/** Risultato normalizzato mostrato nella palette. */
export interface SearchResult {
  section: SearchSection;
  title: string;
  subtitle?: string;
  icon: string;
  /** Eseguito alla selezione (di norma una navigazione). */
  action: () => void;
}

/** Voce statica del catalogo (pagina o azione). */
export interface SearchEntry {
  label: string;
  keywords: string[];
  icon: string;
  /** Segmento di rotta dopo `:organizationId` (es. 'invoices_table'). */
  path: string;
}

/** Pagine/sezioni navigabili dal menu laterale. */
export const SEARCH_PAGES: SearchEntry[] = [
  {
    label: 'Dashboard',
    keywords: ['home', 'panoramica', 'riepilogo', 'inizio'],
    icon: 'dashboard',
    path: 'dashboard',
  },
  {
    label: 'Fatture',
    keywords: ['fatture', 'fatturazione', 'documenti fiscali', 'emesse'],
    icon: 'payments',
    path: 'invoices_table',
  },
  {
    label: 'Clienti',
    keywords: ['clienti', 'aziende', 'anagrafica', 'company'],
    icon: 'groups',
    path: 'company_table',
  },
  {
    label: 'Bozze',
    keywords: ['bozze', 'draft', 'non emesse'],
    icon: 'drafts',
    path: 'drafts_table',
  },
  {
    label: 'Preventivi',
    keywords: ['preventivi', 'quote', 'proposte'],
    icon: 'content_paste_go',
    path: 'preventives_table',
  },
  {
    label: 'Prodotti salvati',
    keywords: ['prodotti', 'articoli', 'catalogo', 'servizi'],
    icon: 'bookmark_added',
    path: 'savedproducts_table',
  },
  {
    label: 'Documenti',
    keywords: ['documenti', 'allegati', 'file'],
    icon: 'library_books',
    path: 'documents_table',
  },
  {
    label: 'Dichiarazione dei redditi',
    keywords: ['dichiarazione', 'redditi', 'tasse', 'imposte', '730', 'unico'],
    icon: 'description',
    path: 'dichiarazione',
  },
  {
    label: 'Piano fiscale',
    keywords: ['piano fiscale', 'scadenze', 'previsioni', 'fiscal plan'],
    icon: 'event_note',
    path: 'fiscal_plan',
  },
  {
    label: 'Corrispettivi',
    keywords: ['corrispettivi', 'scontrini', 'ricevute', 'receipts'],
    icon: 'point_of_sale',
    path: 'corrispettivi-receipts',
  },
  {
    label: 'Notifiche e avvisi',
    keywords: ['messaggi', 'inbox', 'posta', 'notifiche'],
    icon: 'mail',
    path: 'inbox',
  },
  {
    label: 'Guide e FAQ',
    keywords: ['guide', 'faq', 'aiuto', 'help', 'domande'],
    icon: 'help_outline',
    path: 'guides',
  },
  {
    label: 'Invita e guadagna',
    keywords: ['referral', 'invita', 'amici', 'promo'],
    icon: 'accessibility_new',
    path: 'referral',
  },
  {
    label: 'Commercialista',
    keywords: ['commercialista', 'ticket', 'assistenza', 'supporto', 'chat'],
    icon: 'chat_bubble',
    path: 'commercialista-tickets',
  },
  {
    label: 'Profilo',
    keywords: ['profilo', 'account', 'impostazioni', 'dati personali'],
    icon: 'account_box',
    path: 'profile',
  },
  {
    label: 'Carica fattura XML',
    keywords: ['carica', 'importa', 'xml', 'upload fattura'],
    icon: 'upload_file',
    path: 'upload_xml',
  },
  // {
  //   label: 'Importa clienti da Excel',
  //   keywords: ['importa', 'clienti', 'excel', 'upload', 'anagrafica'],
  //   icon: 'grid_on',
  //   path: 'upload_company_list_from_excel',
  // },
  {
    label: 'Carica corrispettivi XML',
    keywords: ['carica', 'importa', 'corrispettivi', 'xml', 'upload'],
    icon: 'upload_file',
    path: 'upload_corrispettivi_xml',
  },
];

/** Azioni rapide di creazione. */
export const SEARCH_ACTIONS: SearchEntry[] = [
  {
    label: 'Nuova fattura',
    keywords: ['nuova fattura', 'crea fattura', 'aggiungi fattura', 'emetti'],
    icon: 'note_add',
    path: 'new_invoice',
  },
  {
    label: 'Nuovo cliente',
    keywords: [
      'nuovo cliente',
      'crea cliente',
      'aggiungi azienda',
      'nuova azienda',
    ],
    icon: 'person_add',
    path: 'new_company',
  },
  {
    label: 'Nuovo preventivo',
    keywords: ['nuovo preventivo', 'crea preventivo', 'aggiungi preventivo'],
    icon: 'content_paste_go',
    path: 'new_preventive',
  },
  {
    label: 'Nuovo prodotto',
    keywords: [
      'nuovo prodotto',
      'crea prodotto',
      'aggiungi articolo',
      'nuovo servizio',
    ],
    icon: 'add_box',
    path: 'new_savedproduct',
  },
  {
    label: 'Carica XML',
    keywords: ['carica xml', 'importa fattura', 'upload xml'],
    icon: 'upload_file',
    path: 'upload_xml',
  },
];
